import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'OrderFlow Kenya';
const DEFAULT_DESCRIPTION = "Kenya's smart platform for restaurant ordering & delivery";
const DEFAULT_IMAGE = '/logo192.png';
const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://store.orderflow.co.ke';

export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  noindex = false,
  canonical
}) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `OrderFlow Kenya | Order & Delivery Platform`;
  const fullUrl = url
    ? `${SITE_URL}${url}`
    : SITE_URL;
  const fullImage = image.startsWith('http')
    ? image
    : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
}
